// START_MODULE pages_main_sections_contacts_components_contactitem_contactitem_tsx
// START_CONTRACT
// PURPOSE: Render one social destination with its label and QR code.
// OPERATIONAL_CONTEXT: Used by the public social-links section.
// CONTRACT: Open the social destination in a new tab and mark the label with an external-link icon.
// KEYWORDS: social-link, qr, external-link, static-site
// COMPLEXITY: 2
// END_CONTRACT
import React from 'react';
import styled, { css } from 'styled-components';

import Link from 'components/atoms/link/Link';
import ExternalLinkIcon from 'components/atoms/icons/ExternalLinkIcon';

import { IChildren } from 'utils/interfaces/IChildren';

interface ContactItemProps extends IChildren {
  qr: any;
  link: string;
  linkText: string;
}

const ContactItem: React.FC<ContactItemProps> = ({
  qr, link, linkText, children,
}) => (
  <ContactWrapper>
    <LinkText>
      { children }
      <Link href={link} target="_blank" rel="noreferrer">
        { linkText }
        <ExternalLinkIcon size={16} />
      </Link>
    </LinkText>

    <div>
      <QrCodeImage src={qr} />
    </div>
  </ContactWrapper>
);

const ContactWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: fit-content;
`;

const LinkText = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 4px;

    > svg {
      transition: color .3s ease-in-out;
    }

    &:hover > svg {
      color: ${theme.accentColor};
    }
  `};
`;

const QrCodeImage = styled.img`
  height: 200px;
  width: 200px;
`;

export default ContactItem;

// END_MODULE pages_main_sections_contacts_components_contactitem_contactitem_tsx
